<!--**Text to get translations into variable**-->
<p i18n id="born" style="display:none;">Born: </p>
<p i18n id="married" style="display:none;">Married: </p>
<p i18n id="deceased" style="opacity:none;">Deceased: </p>
<!--**Text to get translations into variable**-->
<mat-drawer-container class="dashboard-container">
  <mat-drawer-content>
    <div class="loader-div" *ngIf="showLoader">
      <div class="loader"></div>
    </div>
    <div class="content">
      <a [href]="fileUrl" download="file.txt" *ngIf="admin">DownloadFile</a>
      <div class="header" *ngIf="!admin">
        <h2 i18n> My Family tree</h2>
        <ul class="navbar-nav ml-auto py-4 py-md-0 desk-functions">
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="selectBackground()">
            <a i18n >Background</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" [matMenuTriggerFor]="menu">
            <a i18n >Layout</a>
          </li>
          <mat-menu #menu="matMenu">
            <button i18n mat-menu-item (click)="selectTreeType(1)">Left to Right</button>
            <button i18n mat-menu-item (click)="selectTreeType(2)">Right to Left</button>
            <button i18n mat-menu-item (click)="selectTreeType(3)">Top to Bottom</button>
            <button i18n mat-menu-item (click)="selectTreeType(4)">Bottom to Top</button>
            <button i18n mat-menu-item (click)="selectTreeType(5)">From Center</button>
          </mat-menu>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="change_size()">
            <a i18n >Settings</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="reloadtree()">
            <a i18n >Reload Tree</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="showtotal()">
            <a i18n >100% Show</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="generate()">
            <a i18n >Preview</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-6 btn-header" (click)="saveDesignAs()">
            <mat-icon>save</mat-icon>
            <a i18n >Save as new</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="saveDesign()" *ngIf="existingDesignId">
            <mat-icon>save</mat-icon>
            <a i18n >Save my tree</a>
          </li>
          <button class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="checkWarning()" >
            <mat-icon>print</mat-icon>
            <a i18n >Order my tree</a>
          </button>
        </ul>

      </div>
      <div class="m-header">
        <ul class="navbar-nav ml-auto py-4 py-md-0 mobile-functions">
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="generate()">
            <a i18n >Preview</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header">
            <mat-icon>save</mat-icon>
            <a i18n >Save my tree</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="orderPrint()">
            <mat-icon>print</mat-icon>
            <a i18n >Order my tree</a>
          </li>
        </ul>
      </div>


      <div class="tree-body"></div>

      <div class="m-bottom-header">
        <ul class="navbar-nav ml-auto py-4 py-md-0 mobile-functions">
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" routerLink="/dashboard/selection">
            <a i18n >New selction</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="selectBackground()">
            <a i18n >Background</a>
          </li>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" [matMenuTriggerFor]="menu">
            <a i18n >Layout</a>
          </li>
          <mat-menu #menu="matMenu">
            <button i18n mat-menu-item (click)="selectTreeType(1)">Left to Right</button>
            <button i18n mat-menu-item (click)="selectTreeType(2)">Right to Left</button>
            <button i18n mat-menu-item (click)="selectTreeType(3)">Top to Bottom</button>
            <button i18n mat-menu-item (click)="selectTreeType(4)">Bottom to Top</button>
            <button i18n mat-menu-item (click)="selectTreeType(5)">From Center</button>
          </mat-menu>
          <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4 btn-header" (click)="change_size()">
            <a i18n >Settings</a>
          </li>
        </ul>
      </div>

      <button i18n class="d-none" id="submit-setting" (click)="settingUpdate()"></button>
      <mat-card class="setting">
        <mat-card-header>
          <mat-card-title i18n>SETTINGS</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row"><p i18n  >Paper Type: </p><p i18n >&nbsp; {{p_type}}</p> </div>
          <div class="row"><p i18n  >Male: &nbsp; <canvas id='m_color' width="20" height="20"
              [ngStyle]="{'background-color': m_Color}"></canvas> </p><p i18n >{{m_Color}}</p></div>
          <div class="row"><p i18n  >Male Background: &nbsp; <canvas id='m_color' width="20" height="20"
              [ngStyle]="{'background-color': m_b_Color}"></canvas> </p><p i18n >&nbsp;{{m_b_Color}}</p></div>
          <div class="row"><p i18n  >Female: &nbsp; <canvas id='m_color' width="20" height="20"
              [ngStyle]="{'background-color': w_Color}"></canvas> </p><p i18n >&nbsp; {{w_Color}}</p></div>
          <div class="row"><p i18n  >Female Background: &nbsp; <canvas id='m_color' width="20" height="20"
              [ngStyle]="{'background-color': w_b_Color}"></canvas> </p><p i18n >&nbsp; {{w_b_Color}}</p></div>
          <div class="row"><p i18n  >Border Color: &nbsp; <canvas id='m_color' width="20" height="20"
              [ngStyle]="{'background-color': b_Color}"></canvas> </p><p i18n >&nbsp; {{b_Color}}</p></div>
          <div class="row"><p i18n  >Border Width: </p><p i18n >&nbsp; {{b_Width}}</p></div>
          <div class="row"><p i18n  >Background Opacity: </p><p i18n >&nbsp; {{back_Opacity}}</p></div>
          <div class="row"><p i18n  >Node Opacity: </p><p i18n >&nbsp; {{node_Opacity}}</p></div>
          <div class="row"><p i18n  >Max Generation: </p><p i18n >&nbsp; {{max_generation}}</p></div>
          <div class="row"><p i18n  >Corner Round: </p><p i18n >&nbsp; {{cornerRound}} </p></div>
          <div class="row"><p i18n  >Empty Node: </p><p i18n >&nbsp; {{empty_node}} </p></div>
          <div class="row"><p i18n  >Name Text align: </p><p i18n >&nbsp; {{name_text_align}}</p> </div>
          <div class="row"><p i18n  >Other Text align: </p> <p i18n >&nbsp; {{text_align}} </p></div>
          <div class="row"><p i18n  >Birth Visibility: </p> <p i18n >&nbsp; {{birthSetting}} </p></div>
          <div class="row"><p i18n  >Marriage Visibility: </p><p i18n >&nbsp; {{marriageSetting}} </p></div>
          <div class="row"><p i18n  >Death Visibility: </p><p i18n >&nbsp; {{deathSetting}} </p></div>
          <div class="row"><p i18n  >Wife/Husband Visibility: </p><p i18n >&nbsp; {{partner_setting}} </p></div>
          <div class="row"><p i18n  >Children Visibility: </p><p i18n >&nbsp; {{children_setting}} </p></div>
          <div class="row"><p i18n  >Flag Visibility: </p><p i18n >&nbsp; {{flag_setting}} </p></div>
          <div class="row"><p i18n  >Avatar Visibility: </p><p i18n >&nbsp; {{profile_setting}}</p></div>
          <div class="row"><p i18n  >Global Padding: </p><p i18n >&nbsp; {{global_padding}}% </p></div>
          <div class="row"><p i18n  >Warning Visibility:  </p><p i18n >&nbsp; {{warning_setting}}</p></div>
        </mat-card-content>
      </mat-card>
    </div>

  </mat-drawer-content>
</mat-drawer-container>